<template>
  <div>
    <section class="l-home">
      <div class="l-home__navbar">
        <img src="static/tempAssets/fir-logo.svg" alt class="l-home__navbar__logo" />
      </div>
      <div class="container">
        <div class="col-12 col-md-6 col-lg-7">
          <div class="l-home__content">
            <h1 class="l-home__title">{{$t('homepage.home-hero.title')}}</h1>
            <h2 class="l-home__subtitle">{{$t('homepage.home-hero.subtitle')}}</h2>
            <div class="l-home__buttons_container">
              <template v-for="touchpoint in $store.state.campaign.identity_touchpoints">
                <template v-if="touchpoint.provider == 'google'">
                  <button
                    @click="getSocialLoginLink(touchpoint.provider)"
                    v-bind:key="touchpoint.provider"
                    class="btn btn-google"
                  >
                    <div
                      v-bind:key="touchpoint.provider"
                      v-html="icons.google"
                      class="google-logo"
                      style="display:inline-block; width:24px"
                    ></div>Google
                  </button>
                </template>
                <template v-else>
                  <social-button
                    @click="getSocialLoginLink(touchpoint.provider)"
                    v-bind:key="touchpoint.provider"
                    :iconClass="touchpoint.presenter.icon.class"
                    :buttonClass="touchpoint.presenter.class+' l-home__button'"
                    :providerLabel="touchpoint.presenter.label"
                  ></social-button>
                </template>
              </template>
              <div
                v-if="Object.keys($store.state.campaign.identity_touchpoints).length > 0"
                class="or-separator l-home__separator"
              >oppure accedi con</div>
              <button
                class="btn btn-primary icon-left l-home__button l-home__button--email"
                @click="$router.push({ name: 'login'})"
              >
                <template v-if="$store.state.brand.idm_phone_login_enabled">Email</template>
                <template v-else>
                  <i class="fas fa-sign-in"></i>
                  {{$t('homepage.home-hero.email-login')}}
                </template>
              </button>
            </div>
            <!-- <div class="l-home__login__container">
              <div class="l-home__login__wrapper">
                <input type="text" id="l-home__login__input" v-model="login.credential" />
                <label
                  for="l-home__login__input"
                  :class="[login.credential ? 'isActive' : '']"
                >Username</label>
              </div>
              <div class="l-home__login__wrapper">
                <input type="password" id="l-home__login__input" v-model="login.password" />
                <label
                  for="l-home__login__input"
                  :class="[login.password ? 'isActive' : '']"
                >Password</label>
              </div>
              <button class="btn login-button" @click="signin()">Accedi</button>
            </div>-->
          </div>
        </div>
      </div>
    </section>
    <BoxContainer></BoxContainer>
    <div class="l-home__container">
      <!-- <CarouselContainer :catalog="homeData.catalog"></CarouselContainer> -->
      <MissionContainer :actions="homeData.actions"></MissionContainer>
    </div>
    <div
      class="l-home__scroller animated fadeIn"
      v-show="windowTop > 1050"
      v-on:click="scrollToTop()"
    >
      <i class="fas fa-angle-up"></i>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
import _ from "lodash";
import SocialButton from "../Campaign/SocialButton";
import BoxContainer from "./BoxContainer";
import CarouselContainer from "./CarouselContainer";
import MissionContainer from "./MissionContainer";
import iconGoogle from "../../assets/svg/google_G_logo.svg";

export default {
  data() {
    return {
      windowTop: 0,
      icons: {
        google: iconGoogle,
        garmin: "iconGarminConnect"
      },
      appleButton: "appleButton",
      homeData: {
        catalog: [
          {
            image: "fir-catalog1",
            title:
              " Guess Who? Quanto conosci le atlete di Italdonne? (18 maggio)",
            cost: "Gioca"
          }
          // {
          //   image:'biglietto',
          //   title:'30% di sconto sul biglietto del campionato LBA',
          //   cost:600
          // },
          // {
          //   image:'tiro',
          //   title:'Pratice Time',
          //   cost:400
          // },
        ],
        actions: [
          {
            type: "mgm",
            title: "Porta un amico in FIR",
            points: 10
          },
          {
            type: "question",
            title: "Qual è il tuo giocatore preferito?",
            points: 10
          },
          {
            type: "social",
            title:
              "Twitta utilizzando #Italrugby e condividi la tua esperienza",
            points: 10
          }
        ]
      },
      login: {
        credential: "",
        password: ""
      }
    };
  },
  beforeCreate() {
    // this.$http
    //   .get(
    //     "/api/v1/campaigns/" + this.$store.state.campaign.id + "/home/settings"
    //   )
    //   .then(response => {
    //     console.log(response);
    //     this.homeData = response.data.data;
    //   });
  },
  created() {
    const parsedDomain = parseDomain(window.location.hostname);
    if (this.$route.query.ref !== undefined) {
      Cookies.set("mgm", this.$route.query.ref, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }

    if (this.$route.query.mgm_code !== undefined) {
      Cookies.set("mgm_code", this.$route.query.mgm_code, {
        expires: 1,
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onScroll(e) {
      this.windowTop =
        window.top.scrollY; /* or: e.target.documentElement.scrollTop */
      console.log(this.windowTop);
    },
    getSocialLoginLink(provider) {
      this.$http
        .get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            provider +
            "/socialLoginUrl"
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (response.data.data.url && parseDomain) {
            Cookies.set("fanize_social_fallback", window.location.hostname, {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            window.location = response.data.data.url;
          }
        });
    },
    async appleLogin() {
      const response = await this.$http.get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/apple/web/login"
      );
      const parsedDomain = parseDomain(window.location.hostname);
      Cookies.set("fanize_social_fallback", window.location.hostname, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_campaign_id", this.$store.state.campaign.id, {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });
      Cookies.set("fanize_apple_state", _.get(response, "data.data.uuid"), {
        domain: "." + parsedDomain.domain + "." + parsedDomain.tld
      });

      window.location = _.get(response, "data.data.url");
    },
    signin() {
      this.$store.commit("showSpinner");
      this.$http
        .post(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/login",
          this.login
        )
        .then(response => {
          localStorage.setItem("token", response.data.data.token.access_token);
          this.$store.state.authorization.access_token =
            response.data.data.token.access_token;
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + response.data.data.token.access_token;
          this.$store.state.authorization.expires_in =
            response.data.data.token.expires_in;
          this.$store.commit("hideSpinner");
          this.$store.dispatch("getUserInfo").then(response => {
            this.pushDeviceInfo();
            this.$router.push({ name: "dashboard" });
          });
        })
        .catch(error => {
          let errorResponse = error.response;
          switch (errorResponse.status) {
            case 422:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: "Invalid data",
                text: "Please retry"
              });
              break;
            case 406:
              if (this.$store.state.brand.idm_external_verify) {
                this.$store.commit("pushMessage", {
                  type: "waiting",
                  title: "Wait!",
                  text: this.$i18n.t("Check your email to verify your account")
                });
              } else {
                this.currentDisplayIfNotDesktop = "confirmation";
                this.showConfirmation = true;
                this.confirmationUserId = errorResponse.data.meta.userId;
                this.confirmationType =
                  errorResponse.data.meta.confirmationType;
                this.confirmationAddress =
                  errorResponse.data.meta.confirmationAddress;
              }
              break;
            case 401:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: "Invalid password",
                text: "Please retry"
              });
              break;
            case 404:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: "Invalid user",
                text: "Please retry"
              });
              break;
            default:
              this.$store.commit("pushMessage", {
                type: "waiting",
                title: this.$i18n.t("Error")
              });
          }
          this.$store.commit("hideSpinner");
        });
    }
  },
  computed: {
    coverImage() {
      return this.$store.state.campaign.image;
    }
  },
  components: {
    SocialButton,
    BoxContainer,
    MissionContainer,
    CarouselContainer
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";
@import "../../assets/css/m-input.css";

body {
  background-color: white;
}

.l-home {
  background: url("/static/tempAssets/hero-fir-mobileOLD.jpg") no-repeat center
    center;
  background-size: cover;
  @include md {
    background: url("/static/tempAssets/hero-firOLD.png") no-repeat center
      center;
    background-size: cover;
  }
  @include xl {
    min-height: 100vh;
  }
}
.l-home__navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  @include md {
    justify-content: flex-start;
    margin-left: 3.5rem;
  }
}
.l-home__navbar__logo {
  width: 30%;
  margin: 2rem 0 0;
  @include md {
    width: 5%;
  }
  @include lg {
    width: 4%;
  }
}
.l-home__container {
  @include lg {
    background-size: cover;
    background: url("/static/tempAssets/fir-container-background.png") no-repeat
      top center;
    background-position: 0px;
  }
}
.l-home__content {
  display: flex;
  flex-direction: column;
  color: black;
  align-items: center;
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 2rem;
  @include md {
    align-items: flex-start;
    text-align: left;
  }
}
.l-home__title {
  font-size: 34px;
  text-transform: uppercase;
  letter-spacing: 1.53px;
  @include lg {
    font-size: 46px;
  }
  font-weight: 600;
}
.l-home__subtitle {
  font-size: 20px;
  letter-spacing: 0.87px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.87px;
  color: white;
  @include lg {
    font-size: 26px;
    max-width: 60%;
  }
}
.l-home__buttons_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 85%;
  margin: 2rem 0;
  @include md {
    max-width: 50%;
  }
  @include lg {
    margin-bottom: 5rem;
  }
}
.l-home__button {
  display: flex;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.7rem;
  height: 50px;
  font-weight: 300;
  max-width: 300px;
  box-shadow: 0px 10px 40px -6px rgba(0, 0, 0, 0.1);
}

.l-home__button--email {
  background: #0058a2;
  color: white;
  font-weight: 400;
  border: 0;
}

.l-home__button--fir {
  background: #0058a2;
  color: white;
  font-weight: 400;
  border: 0;
}

.l-home__button__icon {
  width: 14%;
}
.l-home__separator {
  margin: 1rem 0;
  @include md {
    max-width: 300px;
    text-align: center;
    margin-top: 0.25rem;
  }
}

.l-home__login__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  margin: 2rem 0;
  background-color: white;
  border-radius: 10px;
}

.l-home__login__wrapper {
  position: relative;
  border-radius: 35px;
  margin: 1rem;
  width: 200px;
  &:focus-within {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  }
  @include md {
    width: 250px;
  }
}

label {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  transition: 0.25s;
  left: 1rem;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  padding: 0.25rem;
  background: #fff;
  color: lightgray;
}

input {
  border: 2px solid lightgray;
  padding: 1rem;
  border-radius: 35px;
  width: 100%;
  &:focus {
    border: 2px solid #1e6bb1;
    outline: 0;
  }
  &:focus ~ label {
    top: 4px;
    transition: 0.25s;
    font-size: 12px;
    color: black;
  }
}

label.isActive {
  top: 4px;
  transition: 0.25s;
  font-size: 12px;
  color: black;
}

.btn.login-button {
  border: 2px solid #1e6bb1;
  background-color: #1e6bb1;
  width: 50%;
  color: white;
  border-radius: 45px;
  padding: 10px;
  cursor: pointer;
}
.btn.login-button:hover {
  border: 2px solid #ee5340;
  background-color: #ee5340;
  color: white;
}
.nb-spinner {
  width: 75px;
  height: 75px;
  margin: 0;
  background: transparent;
  border-top: 4px solid #009688;
  border-right: 4px solid transparent;
  border-radius: 50%;
  -webkit-animation: 1s spin linear infinite;
  animation: 1s spin linear infinite;
}
.btn-google {
  display: flex;
  align-items: center;
  height: 50px;
  max-width: 300px;
  justify-content: center;
  margin-bottom: 0.7rem;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.18);
  .google-logo {
    height: 24px;
    margin-right: 0.5rem;
  }
}

.btn-facebook {
  background: #1777f2;
}

.l-home__scroller {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 20px 25px;
  background-color: white;
  border: solid 4px #0058a2;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  i {
    font-size: 20px;
    color: #0058a2;
  }

  @include md {
    display: none;
  }
}
</style>
